import type { IconNode } from '../types';

/**
 * @name printer-3d
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTF2MSIgLz4KICA8cGF0aCBkPSJNMTIgOGg4IiAvPgogIDxwYXRoIGQ9Ik0xNSAyMHYtM2ExIDEgMCAwMC0xLTFIOWExIDEgMCAwMC0xIDF2MyIgLz4KICA8cGF0aCBkPSJNNCAyMGgxNiIgLz4KICA8cGF0aCBkPSJNNCAyMlY0YTIgMiAwIDAxMi0yaDEyYTIgMiAwIDAxMiAydjE4IiAvPgogIDxwYXRoIGQ9Ik00IDhoNCIgLz4KICA8cGF0aCBkPSJNOC42MzUgMTAuMDkzQTIgMiAwIDAxOCA4LjYzMVY3YTEgMSAwIDAxMS0xaDJhMSAxIDAgMDExIDF2MmExIDEgMCAwMS0uMjkzLjcwN2wtMSAxYTEgMSAwIDAxLTEuNDE0IDB6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/printer-3d
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Printer3d: IconNode = [
  ['path', { d: 'M10 11v1' }],
  ['path', { d: 'M12 8h8' }],
  ['path', { d: 'M15 20v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3' }],
  ['path', { d: 'M4 20h16' }],
  ['path', { d: 'M4 22V4a2 2 0 012-2h12a2 2 0 012 2v18' }],
  ['path', { d: 'M4 8h4' }],
  [
    'path',
    {
      d: 'M8.635 10.093A2 2 0 018 8.631V7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-.293.707l-1 1a1 1 0 01-1.414 0z',
    },
  ],
];

export default Printer3d;
